var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisableIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#22313f;stroke-miterlimit:10;stroke-width:1.5px;}.c{fill:#22313f;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.754 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.668,6H6.685A4.322,4.322,0,0,0,2.43,10.386h0a4.322,4.322,0,0,0,4.255,4.386h7.983a4.321,4.321,0,0,0,4.255-4.363h0A4.334,4.334,0,0,0,14.668,6Z",
    transform: "translate(-2.43 -6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.856,
    cy: 1.856,
    r: 1.856,
    transform: "translate(2.669 2.553)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1.5,
    height: 3.253,
    transform: "translate(11.015 2.765)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableIcon);
export default __webpack_public_path__ + "static/media/disable-icon.5ff61355a94af3b40ff685ace9ac5514.svg";
export { ForwardRef as ReactComponent };